import type { ThemeMode } from '@store/appConfig/types';
import type { ColorsMap } from '@themes/types/theme';

import { getGreyColors } from '@themes/utils/getGreyColors';

interface IColorsTreeParameters {
  mode: ThemeMode;
  colorsMap: ColorsMap;
}

export const getColorsTree = ({ mode, colorsMap }: IColorsTreeParameters) => {
  const greyColors = getGreyColors(mode);

  const primaryColors = colorsMap.primary[mode];
  const warningColors = colorsMap.warning[mode];
  const errorColors = colorsMap.error[mode];
  const infoColors = colorsMap.info[mode];
  const successColors = colorsMap.success[mode];

  const contrastBackground = colorsMap.contrastBackground[mode][0];
  const contrastText = colorsMap.contrastText[mode][0];

  return {
    grey: greyColors,
    success: {
      contrastText,
      dark: successColors[3],
      main: successColors[2],
      light: successColors[1],
      darker: successColors[4],
      lighter: successColors[0],
    },
    warning: {
      contrastText,
      dark: warningColors[3],
      main: warningColors[2],
      light: warningColors[1],
      darker: warningColors[4],
      lighter: warningColors[0],
    },
    info: {
      contrastText,
      dark: infoColors[3],
      main: infoColors[2],
      A700: infoColors[5],
      light: infoColors[1],
      darker: infoColors[4],
      lighter: infoColors[0],
    },
    error: {
      contrastText,
      900: errorColors[9],
      700: errorColors[7],
      400: errorColors[4],
      200: errorColors[2],
      100: errorColors[1],
      dark: errorColors[6],
      main: errorColors[5],
      light: errorColors[3],
      darker: errorColors[8],
      lighter: errorColors[0],
    },
    primary: {
      contrastText,
      contrastBackground,
      900: primaryColors[9],
      700: primaryColors[7],
      400: primaryColors[4],
      200: primaryColors[2],
      100: primaryColors[1],
      dark: primaryColors[6],
      main: primaryColors[5],
      light: primaryColors[3],
      darker: primaryColors[8],
      lighter: primaryColors[0],
    },
    secondary: {
      contrastText,
      A100: greyColors[0],
      800: greyColors[800],
      600: greyColors[600],
      400: greyColors[400],
      200: greyColors[200],
      100: greyColors[100],
      A300: greyColors.A700,
      A200: greyColors.A400,
      dark: greyColors[700],
      main: greyColors[500],
      light: greyColors[300],
      darker: greyColors[900],
      lighter: greyColors[100],
    },
  };
};
